import React from "react";
import styles from "./Truncate.module.css";

const Truncate = ({ className, children }) => (
  <div className={`${styles.clamp}${className ? ` ${className}` : ""}`}>
    {children}
  </div>
);

export { Truncate };
